import {EventEmitter, Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {SettingsParcels, SettingsSms} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {EmailService} from './email.service';
import {AccountPermissionsService} from './account-permissions.service';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const $: any;

@Injectable()
export class SettingsParcelsService {
    data = {
        allSettingsParcels: {
            get: '/v1/amenity?expand=buildingAmenity,createdBy,fees,disabledDates,staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings',
            data: [],
            total: null
        },
    };
    showCreateModal = false;
    isDisabledDatesModalShow = false;
    isLegalAgreementModalShow = false;
    isNotificationModalShow = false;
    isSmsNotificationModalShow = false;
    isShowSmsReminderTextModal = false;
    isPackageTypeModalShow = false;
    isCouriersModalShow = false;
    isStorageLocationsModalShow = false;
    isShowReminderTextModal = false;
    showDetailedView = true;
    selectedItemData: SettingsParcels;
    spinnerShow = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    corporations: any = {
        data: [],
        total: null
    };
    buldingsInMultiselectFormat: Array<any> = [];
    selectedItemFormattedBuildingsArray: Array<any> = [];
    modalSpinnerShow = false;
    showServiceUnavailable = false;
    serviceName: string = 'parcels';
    userRoles: Array<any> = [];
    receivedStaffMultiselectArray: Array<any> = [];
    pickedUpStaffMultiselectArray: Array<any> = [];
    returnedStaffMultiselectArray: Array<any> = [];
    canceledStaffMultiselectArray: Array<any> = [];
    modifiedStaffMultiselectArray: Array<any> = [];
    deletedStaffMultiselectArray: Array<any> = [];
    parcelReceivedStaffCheckbox = false;
    parcelPickedUpStaffCheckbox = false;
    parcelReturnedStaffCheckbox = false;
    parcelCanceledStaffCheckbox = false;
    parcelModifiedStaffCheckbox = false;
    parcelDeletedStaffCheckbox = false;
    parcelReceivedResidentCheckbox = false;
    parcelPickedUpResidentCheckbox = false;
    parcelReturnedResidentCheckbox = false;
    parcelCanceledResidentCheckbox = false;
    parcelModifiedResidentCheckbox = false;
    parcelDeletedResidentCheckbox = false;
    parcelReceivedSmsResidentCheckbox = false;
    parcelPickedUpSmsResidentCheckbox = false;
    parcelReturnedSmsResidentCheckbox = false;
    parcelCanceledSmsResidentCheckbox = false;
    parcelModifiedSmsResidentCheckbox = false;
    parcelDeletedSmsResidentCheckbox = false;
    notificationModalStaffOrResident = '';
    notificationModalNotificationType = '';
    onDetailedViewToggle: EventEmitter<any> = new EventEmitter();
    smsSettings: SettingsSms;

    constructor(public es: EmailService,
                public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?order-by=name|asc`;
        this.api.getInfiniteList('domainBD', url, 1000).subscribe(
            (res) => {
                this.buildings = res.entities;
                this.getFilteredBuildings();
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    getCorporations(scrollToTop?): void {
        this.getCorporationsByQueryParams(scrollToTop).subscribe();
    }

    getCorporationsByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        let queryParams = this.urlService.getQueryParamsString();
        if (queryParams && queryParams.indexOf('&order-by=') != -1) {
            queryParams = queryParams.slice(0, queryParams.indexOf('&order-by=')); // will not this thing destroy the world?
        }
        const url = `/v1/corporation_number.json?${queryParams}&expand=buildings`;
        return this.api.getJson('domainBD', url).pipe(
            createInitialNetworkEntity(),
            resolveNetworkEntity(),
            tap(({loading}) => this.spinnerShow = loading),
            tap(
                (res) => {
                    this.corporations.data = res.entities;
                    this.corporations.total = res.total;
                    this.emptyRowService.fillEmptyRow();
                    if ($('.table')[0] && scrollToTop)
                        $('.table')[0].scrollIntoView();
                },
                (error) => {
                    this.showServiceUnavailable = true;
                    this.spinnerShow = false;
                    this.api.errorHandler(error, 'Failed get corporations');
                }
            )
        );
    }

    resetData() {
        this.corporations.data = [];
        this.corporations.total = null;
    }

    toggleDetailedView(data, state: boolean): void {
        this.selectedItemData = data ? data : null;
        this.corporations.data.forEach(item => item.checked = false);
        if (state) {
            data.checked = true;
            this.emptyNotificationArrays();
            this.getSettingsForCorporation(data.id);
            this.onDetailedViewToggle.emit();
        }
        this.showDetailedView = state;
    }

    canEdit(buildingId?: number) {
        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {
        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
        this.buldingsInMultiselectFormat = this.getBuildingsInProperFormat(this.buildings);
    }

    getBuildingsInProperFormat(arr: Array<any>) {
        return arr.map(building => ({id: parseInt(building.id), itemName: building.name}));
    }

    public getUserRoles() {
        const url = `/api/v1/role.json`;
        this.api.getInfiniteList('oauthUrl', url, 1000).subscribe(
            res => {
                this.userRoles = res.entities.map(role => ({id: role.id.toString(), itemName: role.name}));
            },
            error => this.api.errorHandler(error, 'Failed get Roles')
        );
    }

    public formatNotificationSettingsRoles(): any {
        if (this.selectedItemData) {
            this.selectedItemData.staffNotificationSettings.forEach((notificationSetting) => {
                const actionPart = notificationSetting.action != 'picked_up' ? (notificationSetting.action.charAt(0).toUpperCase() + notificationSetting.action.slice(1)) : 'PickedUp';
                this['parcel' + actionPart + 'StaffCheckbox'] = notificationSetting.enableStatus;
                notificationSetting.userRoles.forEach((role) => {
                    const action = notificationSetting.action == 'picked_up' ? 'pickedUp' : notificationSetting.action;
                    this[action + 'StaffMultiselectArray'].push({
                        id: role.bdId,
                        itemName: role.roleName
                    });
                });
            });
            this.selectedItemData.residentsNotificationSettings.forEach((resNotification) => {
                const actionPart = resNotification.action != 'picked_up' ? (resNotification.action.charAt(0).toUpperCase() + resNotification.action.slice(1)) : 'PickedUp';
                this['parcel' + actionPart + 'ResidentCheckbox'] = resNotification.enableStatus;
            });
            this.selectedItemData.residentsSmsNotificationSettings.forEach((resNotification) => {
                const actionPart = resNotification.action != 'picked_up' ? (resNotification.action.charAt(0).toUpperCase() + resNotification.action.slice(1)) : 'PickedUp';
                this['parcel' + actionPart + 'SmsResidentCheckbox'] = resNotification.enableStatus;
            });

        }
    }

    emptyNotificationArrays(): void {
        this.receivedStaffMultiselectArray = [];
        this.pickedUpStaffMultiselectArray = [];
        this.returnedStaffMultiselectArray = [];
        this.canceledStaffMultiselectArray = [];
        this.modifiedStaffMultiselectArray = [];
        this.deletedStaffMultiselectArray = [];
        this.parcelReceivedStaffCheckbox = false;
        this.parcelPickedUpStaffCheckbox = false;
        this.parcelReturnedStaffCheckbox = false;
        this.parcelCanceledStaffCheckbox = false;
        this.parcelModifiedStaffCheckbox = false;
        this.parcelDeletedStaffCheckbox = false;
        this.parcelReceivedResidentCheckbox = false;
        this.parcelPickedUpResidentCheckbox = false;
        this.parcelReturnedResidentCheckbox = false;
        this.parcelCanceledResidentCheckbox = false;
        this.parcelModifiedResidentCheckbox = false;
        this.parcelDeletedResidentCheckbox = false;
        this.parcelReceivedSmsResidentCheckbox = false;
        this.parcelPickedUpSmsResidentCheckbox = false;
        this.parcelReturnedSmsResidentCheckbox = false;
        this.parcelCanceledSmsResidentCheckbox = false;
        this.parcelModifiedSmsResidentCheckbox = false;
        this.parcelDeletedSmsResidentCheckbox = false;
    }

    getSettingsForCorporation(corporationNumberId) {
        const corporationName = (<any>this.selectedItemData).name;
        this.selectedItemData = null;
        const url = `/v1/parcel-service-settings/${corporationNumberId}.json?expand=staffNotificationSettings,staffNotificationSettings.userRoles,residentsNotificationSettings,residentsSmsNotificationSettings,parcelTypes,parcelPostServices,parcelStorageLocations`;
        this.api.get('domainParcels', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.selectedItemData = body ? this.settingsParcelsFactory(body) : new SettingsParcels();
                this.selectedItemData.corporationNumberName = corporationName;
                this.formatNotificationSettingsRoles();
                this.getSmsSettingsForCorporation(corporationNumberId);
            },
            error => {
                if (error.statusText == 'Not Found') {
                    this.selectedItemData = new SettingsParcels();
                    this.selectedItemData.id = corporationNumberId;
                    this.selectedItemData.corporationNumberName = corporationName;
                    this.getSmsSettingsForCorporation(corporationNumberId);
                } else
                    this.api.errorHandler(error, 'Failed to get parcels settings for the chosen corporation');
            }
        );
    }

    getSmsSettingsForCorporation(corporationNumberId) {
        this.smsSettings = null;

        const url = `/v1/cn_settings/${corporationNumberId}.json`;
        this.api.get('domainSms', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.smsSettings = body;
            },
            error => {
                if (error.statusText == 'Not Found') {
                    this.smsSettings = new SettingsSms();
                }
            }
        );
    }

    settingsParcelsFactory(setting) {
        const parcelSetting = new SettingsParcels();

        if (setting.id) parcelSetting.id = setting.id;
        if (setting.emailSender) parcelSetting.emailSender = setting.emailSender;
        if (setting.emailSenderName) parcelSetting.emailSenderName = setting.emailSenderName;
        if (setting.corporationNumberBd) parcelSetting.corporationNumberBd = setting.corporationNumberBd;
        if (setting.dateFormat) parcelSetting.dateFormat = setting.dateFormat;
        if (setting.manualReminder) parcelSetting.manualReminder = setting.manualReminder;
        if (setting.parcelPostServices) parcelSetting.parcelPostServices = setting.parcelPostServices;
        if (setting.parcelStorageLocations) parcelSetting.parcelStorageLocations = setting.parcelStorageLocations;
        if (setting.parcelTypes) parcelSetting.parcelTypes = setting.parcelTypes;
        if (setting.useBarcodeScannerStatus) parcelSetting.useBarcodeScannerStatus = setting.useBarcodeScannerStatus;
        if (setting.showResidentPhotoStatus) parcelSetting.showResidentPhotoStatus = setting.showResidentPhotoStatus;
        if (setting.useSignaturePadStatus) parcelSetting.useSignaturePadStatus = setting.useSignaturePadStatus;
        if (setting.isSendSmsOnlyIfEmailIsEmpty) parcelSetting.isSendSmsOnlyIfEmailIsEmpty = setting.isSendSmsOnlyIfEmailIsEmpty;
        if (setting.residentsNotificationSettings) parcelSetting.residentsNotificationSettings = setting.residentsNotificationSettings;
        if (setting.staffNotificationSettings) parcelSetting.staffNotificationSettings = setting.staffNotificationSettings;
        if (setting.residentsSmsNotificationSettings) parcelSetting.residentsSmsNotificationSettings = setting.residentsSmsNotificationSettings;

        parcelSetting.isCanEdit = setting.isCanEdit;
        parcelSetting.isCanDelete = setting.isCanDelete;

        return parcelSetting;
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/settings-parcels.service.ts